
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import {mapActions, mapGetters, mapState} from 'vuex';
    import moment from 'moment';
    import {
        ImpfstatistikOptions,
        ImpfstatistikOptionsPayload,
        PatientImpfstatistikOptions,
        PatientImpfstatistikPayload
    } from '@/store/statistik';
    import { VMenu } from '@/types/Components';
    import { SelectItems } from '@/types/SelectItems';

    @Component({
        computed: {
            ...mapState('impfstoff', ['impfstoffe']),
            ...mapState('impfstoff', { loadersImpfstoff: 'loaders' }),
            ...mapState('statistik', ['loaders']),
            ...mapGetters('authentication', ['getSystemEinstellung']),
            ...mapState('patient', ['distinctBefundwerttexte']),
            ...mapState('patient', { loadersDistinctBefundwerttexte: 'loaders' }),
            ...mapState('untersuchungen', ['untersuchungen']),
            ...mapState('untersuchungen', { loadersUntersuchungen: 'loaders' }),
        },
        methods: {
            ...mapActions('statistik', ['exportPatientenMitImpfungenExcel']),
            ...mapActions('impfstoff', ['loadImpfstoffe']),
            ...mapActions('patient', ['loadDistinctBefundwerttexte']),
            ...mapActions('untersuchungen', ['loadUntersuchungen']),
        },
    })
    export default class Patientenmitimpfung extends Vue {
        @Prop() public visible!: boolean;

        public $refs!: {
            zeitraumMenu: VMenu;
        };

        public loadImpfstoffe!: () => void;
        public loadDistinctBefundwerttexte!: () => void;
        public loadUntersuchungen!: () => void;
        public exportPatientenMitImpfungenExcel!: (payload: { options: PatientImpfstatistikPayload }) => void;
        public impfungMatch:any | null = null;
        public zeitraumMenu = false;
        public zeitraumErrorMessages: string[] = [];
        public befundVergleichsoperatoren = SelectItems.BEFUND_VERGLEICHSOPERATOREN;

        public options: PatientImpfstatistikOptions = {
            impfstoffe: [],
            zeitraum: [
                moment().subtract(30, 'days').format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD'),
            ],
            impfungMatch: '',
            impfaktion: false,
            untersuchungen: [],
            befundwerttexte: [],
            befundvergleichsoperator: 0,
            befundwert: undefined,
            exportUntersuchungen: true,
        };

        public alleImpfstoffe = false;
        public search = '';


        public get canExport(): boolean {
            const [vonZeitraum, bisZeitraum] = this.options.zeitraum;

            const isOperatorSelected = (this.options.befundvergleichsoperator ?? 0) > 0 && (this.options.befundvergleichsoperator ?? 0) <= 5;
            const isBefundValueEntered = this.options.befundwert != null && this.options.befundwert >= 0;
            const isValidBefundInput = (!isOperatorSelected && !isBefundValueEntered) || (isOperatorSelected && isBefundValueEntered);

            return isValidBefundInput && this.zeitraumErrorMessages.length === 0 &&
                (this.alleImpfstoffe || this.options.impfstoffe.length !== 0 || (this.impfungMatch && this.impfungMatch.length > 2)) &&
                !!vonZeitraum && !!bisZeitraum;
        }

        public get maxZeitraum(): string {
            return moment().format('YYYY-MM-DD');
        }

        public get zeitraumLabel(): string {
            return this.options.zeitraum.length
                ? 'von ' + this.options.zeitraum.sort((a, b) => a.localeCompare(b)).map((date) => {
                    const [year, month, day] = date.split('-');
                    return `${day}.${month}.${year}`;
                }).join(' bis ')
                : '';
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.loadImpfstoffe();
                this.loadDistinctBefundwerttexte();
                this.loadUntersuchungen();
                this.zeitraumErrorMessages = [];
                this.impfungMatch = '';
                this.alleImpfstoffe = false;
                this.options.impfstoffe = [];
                this.options.untersuchungen = [];
                this.options.befundwerttexte = [];
                this.options.befundvergleichsoperator = 0;
                this.options.befundwert = undefined;
                this.options.exportUntersuchungen = true;
            }
        }

        @Watch('zeitraum')
        public onChangeZeitraum(dates: [string, string]): void {
            if (dates?.length === 2) {
                this.options.zeitraum = dates;
            }
        }

        public saveZeitraum(date: [string, string]): void {
            this.options.zeitraum = date;
            this.$refs.zeitraumMenu.save(date);

            this.zeitraumErrorMessages = [];

            const [von, bis] = this.options.zeitraum;
            if (Math.abs(moment(von).diff(moment(bis), 'days')) > 365) {
                this.zeitraumErrorMessages.push('Zeitraum darf nicht mehr als 365 Tage überschreiten.');
            }
        }

        public onClickExport(): void {
            const payload: PatientImpfstatistikPayload = {
                ...this.options,
                zeitraum: this.options.zeitraum.sort((a, b) => a.localeCompare(b)),
                impfungMatch: this.impfungMatch,
            };

            if (this.alleImpfstoffe) {
                delete payload.impfstoffe;
            }

            this.exportPatientenMitImpfungenExcel({ options: payload });
        }
    }
